/**
 * participantTown — the team (town) this device picked after the PIN, per
 * instance. Set by the TownPicker on the PIN path, read by the team laptop
 * pages (default team) and by the solution modal (scenario_id on save).
 *
 * localStorage, like participantId: a convenience for the device, not an
 * identity. Every read and write tolerates a disabled store.
 */
const KEY_PREFIX = 'kuutio-town:';

const keyFor = (instanceId) => `${KEY_PREFIX}${instanceId}`;

/** @returns {{ scenarioId: string, slug: string, name: string } | null} */
export function getTown(instanceId) {
  if (!instanceId || typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(keyFor(instanceId));
    if (!raw) return null;
    const town = JSON.parse(raw);
    return town && typeof town.scenarioId === 'string' ? town : null;
  } catch {
    return null;
  }
}

/** Remembers the team; a team without a scenarioId clears it. */
export function setTown(instanceId, team) {
  if (!instanceId || typeof window === 'undefined') return;
  try {
    if (!team?.scenarioId) {
      window.localStorage.removeItem(keyFor(instanceId));
      return;
    }
    const town = { scenarioId: team.scenarioId, slug: team.slug || null, name: team.name || team.shortName || team.slug || '' };
    window.localStorage.setItem(keyFor(instanceId), JSON.stringify(town));
  } catch { /* storage disabled */ }
}

export function clearTown(instanceId) {
  setTown(instanceId, null);
}
